[ {
  "name" : "Visualization Builder",
  "icon" : "add_chart",
  "path" : "/generate-visualization"
} ]
